module.exports = {
    title: "Email Delivery",
    crud: {
        view: 'Email Delivery View',
    },
    table: {
        name: 'User Name',
        email: 'Email',
        cityName: 'City',
        countryName: 'Country',
        budget: 'Budget',
        description: 'Description',
    },
    form: {
        name: 'User Name',
        email: 'Email',
        mobile: 'Mobile Number',
        cityName: 'City',
        countryName: 'Country',
        budget: 'Budget',
        description: 'Description',
        inquiryIndustry: 'Inquiries Industry',
        yourIndustry: 'Your Industry',
    },
}
